<div class='loading-container' *ngIf="globalLoading">
	<mat-spinner diameter="55"></mat-spinner>
</div>